<div class="filters-for-grid-panel">
    <div style="padding-top: 5px;">Saved filters:</div>
    <div>
        <irb-dropdown-filter #IrbGridFiltersDropdown placeholder="-No filter-"
                             [(value)]="selectedGridFiltersValue"
                             (search)="getGridFilters($event)"
                             size="30"
                             (selection)="onFilterChange()"></irb-dropdown-filter>
    </div>
    <div style="padding-top: 2px;">
        <p-checkbox [(ngModel)]="setAsDefault" binary="true" name="defaultFilter" [disabled]="setAsDefaultDisabled" (onChange)="saveAndApply()" inputId="ffgriditem1"></p-checkbox>
        <label for="ffgriditem1" style="margin-left:.3rem;vertical-align: middle;">Set as default</label>
    </div>
    <div>
        <button class="btn-medium-secondary"
                calltoaction [calltoactionTemplate]="irbDeleteFilterTemplateRef" [calltoactionPosition]="'bottom'"
                [disabled]="!selectedGridFiltersValue || (selectedGridFiltersValue && selectedGridFiltersValue.value === -1)">Delete</button>
    </div>
    <div>
        <button class="btn-medium-primary"
                [disabled]="disableManageButton"
                calltoaction [calltoactionTemplate]="irbSaveFilterTemplateRef" [calltoactionPosition]="'bottom'"
                (click)="getNewUpdateFilterName(); validateSaveButton(newUpdateFilterName);"
        >Manage filters</button>
    </div>

    <ng-template #irbDeleteFilterTemplateRef >
        <div style="min-width:250px;">
            Do you want to delete this saved filter?
            <div style="padding:5px 0">{{selectedGridFiltersValue.name}}</div>
            <div style="padding-top:5px">
                <button class="btn-medium-secondary" (click)="cancelDelete()">Cancel</button>
                <button class="btn-medium-primary" (click)="proceedWithDelete()">Yes, delete</button>
            </div>
        </div>
    </ng-template>

    <ng-template #irbSaveFilterTemplateRef >
        <div style="min-width:250px;" class="manage-save-filter-popup">
            <div style="padding:5px 0;height: 20px;">
                <div style="float:left;">
                    Filter name
                </div>
                <div style="float:right;">
                    <p-checkbox [(ngModel)]="setAsDefault" binary="true" name="defaultFilterOnSave" id="defaultFilterOnSaveChk" inputId="ffgriditem2"></p-checkbox>
                    <label for="ffgriditem2">Set as default</label>
                </div>
            </div>
            <div class="clear" style="padding-top:3px;">
                <irb-validation-text-box #NewUpdateFilterNameTxt max="30" (valueChange)="validateSaveButton($event)"
                                         [(value)]="newUpdateFilterName" regExp="^[a-zA-Z0-9\s]+$"
                                         width="100%" placeholder="filter name"></irb-validation-text-box>
            </div>
            <div style="padding-top:8px">
                <button class="btn-medium-secondary" (click)="cancelDelete()">Cancel</button>
                <button class="btn-medium-primary" (click)="saveAndApply()" [disabled]="disabledSaveBtn">Save and apply</button>
            </div>
        </div>
    </ng-template>
</div>

